import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import LottieGif from 'components/LottieGif';

import styles from './styles';

const useStyles = createUseStyles(styles, 'CopilotLoader');

const CopilotLoader = memo(({ src }) => {
    const classes = useStyles();
    if (!src) return null;
    return (
        <div className={classes.root}>
            <LottieGif src={src} />
        </div>
    );
});

export default CopilotLoader;
